import { render, staticRenderFns } from "./StaffLocVerification.vue?vue&type=template&id=9cad15f8&scoped=true&"
import script from "./StaffLocVerification.vue?vue&type=script&lang=js&"
export * from "./StaffLocVerification.vue?vue&type=script&lang=js&"
import style0 from "./StaffLocVerification.vue?vue&type=style&index=0&id=9cad15f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cad15f8",
  null
  
)

export default component.exports